export function fbTrackBookingEvent(eventName, bookingId) {
  if (!bookingId) {
    window.fbq("track", eventName);
    return;
  }
  window.fbq("track", eventName, {}, { eventID: `${bookingId}_${eventName}` });
}
